<template>
    <div class="ProfessionalReview">
        <div class="table">
            <el-table :data="tableData" style="width: 100%">
                <el-table-column cell-class-name="custom-text-size" width="100" label="序号">
                    <template slot-scope="scope">
                        <span>{{ (page - 1) * SizePage + scope.$index + 1 }}</span>
                    </template>
                </el-table-column>
                <el-table-column cell-class-name="custom-text-size" width="100" prop="name"
                    label="姓名"></el-table-column>
                <el-table-column cell-class-name="custom-text-size" width="100" prop="gender"
                    label="性别"></el-table-column>
                <el-table-column cell-class-name="custom-text-size" width="150" prop="mobile"
                    label="联系电话"></el-table-column>
                <el-table-column cell-class-name="custom-text-size" width="200" prop="user_group_name"
                    label="注册类型"></el-table-column>
                <el-table-column cell-class-name="custom-text-size" prop="status" label="审核结果"></el-table-column>
                <el-table-column cell-class-name="custom-text-size" label="操作">
                    <template slot-scope="scope">
                        <el-button class="" size="mini" @click="LockInfo(scope.row)" v-if="scope.row.status === '未审核'">审核</el-button>
                        <el-button class="" size="mini" @click="LockInfo(scope.row)" v-else>详情</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="PageDis">
                <el-pagination background :page-sizes="[10, 20, 50]" layout="prev,pager,next,total,sizes"
                    @size-change="SizeChange" @current-change="PageChange" :total="total" :current-page="page"
                    :hide-on-single-page="false"></el-pagination>
            </div>
        </div>
        <el-dialog v-if="ReviewBlon" title="专业人员评审详情" :visible.sync="ReviewBlon" width="60%" :show-close="true">
            <div class="CommDig">
                <div class="TitleBox">
                    <span>基本信息</span>
                </div>
                <table width="100%" class="Table" v-if="reviewInfo.personnel">
                    <tbody>
                        <tr>
                            <td width="10%"><span class="Red">*</span>姓名</td>
                            <td width="23%"><el-input size="small" v-model="reviewInfo.personnel.name"
                                    disabled></el-input></td>
                            <td width="10%"><span class="Red">*</span>手机号</td>
                            <td width="23%"><el-input size="small" v-model="reviewInfo.personnel.mobile"
                                    disabled></el-input>
                            </td>
                            <td colspan="2">
                                <label style="margin-right: 10px;"><span class="Red">*</span>是否向公众公布您的联系方式</label>
                                <el-radio-group disabled v-model="reviewInfo.personnel.is_public" size="small">
                                    <el-radio :label="1">是</el-radio>
                                    <el-radio :label="2">否</el-radio>
                                </el-radio-group>
                            </td>
                        </tr>
                        <tr>
                            <td width="10%"><span class="Red">*</span>性别</td>
                            <td width="23%">
                                <el-radio-group v-model="reviewInfo.personnel.gender" disabled size="small">
                                    <el-radio label="1">男</el-radio>
                                    <el-radio label="2">女</el-radio>
                                </el-radio-group>
                            </td>
                            <td><span class="Red">*</span>出生年月</td>
                            <td>
                                <el-input size="small" v-model="reviewInfo.personnel.birthday" disabled></el-input>
                            </td>
                            <td><span class="Red">*</span>籍贯</td>
                            <td>
                                <el-input size="small" v-model="reviewInfo.personnel.native_place" disabled></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td><span class="Red">*</span>民族</td>
                            <td>
                                <el-input size="small" v-model="reviewInfo.personnel.nation" disabled></el-input>
                            </td>
                            <td><span class="Red">*</span>身份证号码</td>
                            <td><el-input size="small" v-model="reviewInfo.personnel.id_card" disabled></el-input></td>
                            <td><span class="Red">*</span>政治面貌</td>
                            <td><el-input size="small" v-model="reviewInfo.personnel.political_party"
                                    disabled></el-input></td>
                        </tr>
                        <tr>
                            <td><span class="Red">*</span>学历</td>
                            <td>
                                <el-input size="small" v-model="reviewInfo.personnel.qualification" disabled></el-input>
                            </td>
                            <td><span class="Red">*</span>学位</td>
                            <td><el-input size="small" v-model="reviewInfo.personnel.degree" disabled></el-input></td>
                            <td><span class="Red">*</span>专业</td>
                            <td><el-input size="small" v-model="reviewInfo.personnel.major" disabled></el-input></td>
                        </tr>
                        <tr>
                            <td><span class="Red">*</span>技术职称</td>
                            <td>
                                <el-input size="small" v-model="reviewInfo.personnel.work_title" disabled></el-input>
                            </td>
                            <td><span class="Red">*</span>工作单位</td>
                            <td colspan="3"><el-input size="small" v-model="reviewInfo.personnel.pf_work"
                                    disabled></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td><span class="Red">*</span>通信地址</td>
                            <td colspan="5">
                                <div class="TableDis">
                                    <el-input size="small" placeholder="请输入详细地址" v-model="reviewInfo.personnel.address"
                                        disabled></el-input>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td><span class="Red">*</span>简介</td>
                            <td colspan="5"><el-input size="small" type="textarea" :rows="2"
                                    v-model="reviewInfo.personnel.synopsis" disabled></el-input></td>
                        </tr>
                    </tbody>
                </table>
                <div class="TitleBox">
                    <span>专业信息</span>
                </div>
                <div>
                    <div class="ZhuanYeWai" v-for="(item, index) in ZhuanYeXinXiInfo" :key="index">
                        <div class="ZhuanYeTheme" v-if="item.question_info">{{ item.question_info.name }}</div>
                            <!-- 父题目本身的答案/文件 -->
                            <div class="ZhuanYeBox" v-if="shouldShowParent(item)">
                                <div class="ZhuanYeBoxInfo">
                                    <div>
                                        <span v-if="item.question_type == 2">
                                            {{ item.question_info.name }}<span style="color: red;"> {{ item.answer
                                                }}
                                            </span>{{
                                                item.question_info.unit
                                            }}</span>
                                        <span v-else-if="item.question_info.type == 2 || item.question_info.type == 4">
                                            {{ item.question_info.name }}<span style="color: red;"> {{ item.answer
                                                }}
                                            </span>{{
                                                item.question_info.unit
                                            }}</span>
                                        <span v-else>{{ item.question_info.name }}</span>
                                        <span v-if="item.question_type != 2 && item.question_info.type != 2 && item.answer" style="color: red; margin-left: 10px;">
                                            {{ item.answer }}
                                        </span>
                                    </div>
                                    <div v-if="item.supervisor">
                                        <div class="SupervisorBox" v-for="(i, indexi) in item.supervisor" :key="indexi">
                                            督导师姓名: <span class="SpanColorRed">{{ i.name }}</span>
                                            注册码: <span class="SpanColorRed">{{ i.code }}</span>
                                            电话: <span class="SpanColorRed">{{ i.mobile }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="item.fileList">
                                    <div class="UploadTitle">上传文件:</div>
                                    <div class="ZhuanYeBoxFile" v-for="(t, indext) in item.fileList" :key="indext">
                                        <div class="FileItem" @click="OpenLock(t)">
                                            <img :title="t.name" :src="$Global._isFileName(t.url)" alt="">
                                            <div :title="t.name" class="FileTitle">{{ t.name }}</div>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="item.templatefileList">
                                    <div class="UploadTitle">文件:</div>
                                    <div class="ZhuanYeBoxFile" v-for="(d, indexd) in item.templatefileList" :key="indexd">
                                        <div class="FileItem" @click="OpenLock(d)">
                                            <img :title="d.name" :src="$Global._isFileName(d.url)" alt="">
                                            <div :title="d.name" class="FileTitle">{{ d.name }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- 子题目 -->
                            <div class="ZhuanYeBox" v-for="(items, indexs) in item.children" :key="indexs">
                                <div class="ZhuanYeBoxInfo">
                                    <div>
                                        <span v-if="items.question_type == 2">{{
                                            indexs +
                                            1 }}. {{ items.question_info.name }}<span style="color: red;"> {{ items.answer
                                                }}
                                            </span>{{
                                                items.question_info.unit
                                            }}</span>
                                        <span v-else-if="items.question_info.type == 2 || items.question_info.type == 4">{{
                                            indexs +
                                            1 }}. {{ items.question_info.name }}<span style="color: red;"> {{ items.answer
                                                }}
                                            </span>{{
                                                items.question_info.unit
                                            }}</span>
                                        <span v-else>{{ indexs +
                                            1 }}. {{ items.question_info.name }}</span>
                                        <span v-if="items.question_type != 2 && items.question_info.type != 2 && items.answer" style="color: red; margin-left: 10px;">
                                            {{ items.answer }}
                                        </span>
                                    </div>
                                    <div v-if="items.supervisor">
                                        <div class="SupervisorBox" v-for="(i, indexi) in items.supervisor" :key="indexi">
                                            督导师姓名: <span class="SpanColorRed">{{ i.name }}</span>
                                            注册码: <span class="SpanColorRed">{{ i.code }}</span>
                                            电话: <span class="SpanColorRed">{{ i.mobile }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="items.fileList">
                                    <div class="UploadTitle">上传文件:</div>
                                    <div class="ZhuanYeBoxFile" v-for="(t, indext) in items.fileList" :key="indext">
                                        <div class="FileItem" @click="OpenLock(t)">
                                            <img :title="t.name" :src="$Global._isFileName(t.url)" alt="">
                                            <div :title="t.name" class="FileTitle">{{ t.name }}</div>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="items.templatefileList">
                                    <div class="UploadTitle">文件:</div>
                                    <div class="ZhuanYeBoxFile" v-for="(d, indexd) in items.templatefileList" :key="indexd">
                                        <div class="FileItem" @click="OpenLock(d)">
                                            <img :title="d.name" :src="$Global._isFileName(d.url)" alt="">
                                            <div :title="d.name" class="FileTitle">{{ d.name }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                <div v-if="reviewInfo.personnel && !reviewInfo.personnel.type">
                    <div class="TitleBox">
                        <span>案例报告</span>
                    </div>
                    <div class="ZhuanYeBox AnLIBaoGaoBox" v-if="reviewInfo.case">
                        <div class="ZhuanYeBoxInfo">
                            <span>1. 案例报告文件</span>
                        </div>
                        <div class="ZhuanYeBoxFile">
                            <div class="FileItem" @click="OpenLock(reviewInfo.case.url)">
                                <img :title="reviewInfo.case.fileName" :src="$Global._isFileName(reviewInfo.case.url)"
                                    alt="">
                                <div :title="reviewInfo.case.fileName" class="FileTitle">{{ reviewInfo.case.fileName }}
                                </div>
                            </div>
                        </div>
                        <div class="ZhuanYeBoxInfo" style="margin-top: 20px;">
                            <span>2. 逐字稿文件</span>
                        </div>
                        <div class="ZhuanYeBoxFile" v-if="reviewInfo.case.zixun_url">
                            <div class="FileItem" @click="OpenLock(reviewInfo.case.zixun_url)">
                                <img :title="reviewInfo.case.zixun_fileName" :src="$Global._isFileName(reviewInfo.case.zixun_url)"
                                    alt="">
                                <div :title="reviewInfo.case.zixun_fileName" class="FileTitle">{{ reviewInfo.case.zixun_fileName }}
                                </div>
                            </div>
                        </div>
                        <div class="ZhuanYeBoxInfo" style="margin-top: 20px;">
                            <span>3. 专业论文</span>
                        </div>
                        <div class="ZhuanYeBoxFile" v-if="reviewInfo.case.lunwen_url">
                            <div class="FileItem" @click="OpenLock(reviewInfo.case.lunwen_url)">
                                <img :title="reviewInfo.case.lunwen_fileName" :src="$Global._isFileName(reviewInfo.case.lunwen_url)"
                                    alt="">
                                <div :title="reviewInfo.case.lunwen_fileName" class="FileTitle">{{ reviewInfo.case.lunwen_fileName }}
                                </div>
                            </div>
                        </div>
                        <div class="ZhuanYeBoxInfo" style="margin-top: 20px;">
                            <span>4. 科普文章1</span>
                        </div>
                        <div class="ZhuanYeBoxFile" v-if="reviewInfo.case.wenzhang1_url">
                            <div class="FileItem" @click="OpenLock(reviewInfo.case.wenzhang1_url)">
                                <img :title="reviewInfo.case.wenzhang1_fileName" :src="$Global._isFileName(reviewInfo.case.wenzhang1_url)"
                                    alt="">
                                <div :title="reviewInfo.case.wenzhang1_fileName" class="FileTitle">{{ reviewInfo.case.wenzhang1_fileName }}
                                </div>
                            </div>
                        </div>
                        <div class="ZhuanYeBoxInfo" style="margin-top: 20px;">
                            <span>5. 科普文章2</span>
                        </div>
                        <div class="ZhuanYeBoxFile" v-if="reviewInfo.case.wenzhang2_url">
                            <div class="FileItem" @click="OpenLock(reviewInfo.case.wenzhang2_url)">
                                <img :title="reviewInfo.case.wenzhang2_fileName" :src="$Global._isFileName(reviewInfo.case.wenzhang2_url)"
                                    alt="">
                                <div :title="reviewInfo.case.wenzhang2_fileName" class="FileTitle">{{ reviewInfo.case.wenzhang2_fileName }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="reviewInfo.personnel && !reviewInfo.personnel.type">
                <div class="TitleBox">
                    <span>推荐信息</span>
                </div>
                <div v-for="(info, infoIndex) in reviewInfo.information" :key="info.id">
                    <div class="ZhuanYeItem" v-if="info.mechanism">
                        <div class="ZhuanYeItemRadio">
                            <label class="radio-label">所在心理服务专业机构</label>
                        </div>
                        <div class="ZhuanYeItemCont">
                            <div class="ZhuanYeItemDis">
                                <div class="ZhuanYeItemFuTit">机构名称</div>
                                <div class="ZhuanYeItemVal"><el-input size="small" disabled
                                        v-model="info.mechanism.name"></el-input></div>
                            </div>
                            <div class="ZhuanYeItemDis">
                                <div class="ZhuanYeItemFuTit">注册码</div>
                                <div class="ZhuanYeItemVal"><el-input size="small" disabled
                                        v-model="info.mechanism.code"></el-input></div>
                            </div>
                        </div>
                    </div>
                    <div class="ZhuanYeItem" v-if="info.tutor">
                        <div class="ZhuanYeItemRadio">
                            <label class="radio-label">注册督导师</label>
                        </div>
                        <div class="ZhuanYeItemCont" v-for="(tutor, index) in info.tutor" :key="index">
                            <div class="ZhuanYeItemTit" v-if="info.tutor.length > 1">注册督导师 {{ index + 1 }}</div>
                            <div class="ZhuanYeItemDis">
                                <div class="ZhuanYeItemFuTit">姓名</div>
                                <div class="ZhuanYeItemVal"><el-input size="small" disabled
                                        v-model="tutor.name"></el-input></div>
                            </div>
                            <div class="ZhuanYeItemDis">
                                <div class="ZhuanYeItemFuTit">注册码</div>
                                <div class="ZhuanYeItemVal"><el-input size="small" disabled
                                        v-model="tutor.code"></el-input></div>
                            </div>
                            <div class="ZhuanYeItemDis">
                                <div class="ZhuanYeItemFuTit">电话</div>
                                <div class="ZhuanYeItemVal"><el-input size="small" disabled
                                        v-model="tutor.mobile"></el-input></div>
                            </div>
                        </div>
                    </div>
                    <div class="ZhuanYeItem" v-if="info.consultant">
                        <div class="ZhuanYeItemCont" v-for="(item, index) in info.consultant" :key="index">
                            <div class="ZhuanYeItemTit">注册心理咨询师 {{ infoIndex + 1 }}</div>
                            <div>
                                <div class="ZhuanYeItemDis">
                                    <div class="ZhuanYeItemFuTit">姓名</div>
                                    <div class="ZhuanYeItemVal"><el-input size="small" disabled
                                            v-model="item.name"></el-input>
                                    </div>
                                </div>
                                <div class="ZhuanYeItemDis">
                                    <div class="ZhuanYeItemFuTit">注册码</div>
                                    <div class="ZhuanYeItemVal"><el-input size="small" disabled
                                            v-model="item.code"></el-input>
                                    </div>
                                </div>
                                <div class="ZhuanYeItemDis">
                                    <div class="ZhuanYeItemFuTit">电话</div>
                                    <div class="ZhuanYeItemVal"><el-input size="small" disabled
                                            v-model="item.mobile"></el-input></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
                <div class="TitleBox">
                    <span>审核</span>
                </div>
                <div class="DigItem">
                    <div class="DigTit">状态</div>
                    <div>
                        <el-radio-group :disabled="status_type !== 0" v-model="SetData.status" size="small">
                            <el-radio :label=1>通过</el-radio>
                            <el-radio :label=2>不通过</el-radio>
                        </el-radio-group>
                    </div>
                </div>
                <div class="DigItem" v-if="SetData.status == 2">
                    <div class="DigTit">驳回理由</div>
                    <div>
                        <el-input size="small" type="textarea" :rows="5" placeholder="请输入"
                            v-model="SetData.reason"></el-input>
                    </div>
                </div>
                <div class="DigBtns">
                    <div class="Btn" @click="ReviewBlon = false, SetData = {}">取消</div>
                    <div v-if="status_type == 0" class="Btn Blue" @click="ReviewSuc">提交</div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
const processStatus = {
    '0': '未审核',
    '1': '已审核',
    '2': '已驳回',
}
export default {
    data() {
        return {
            tableData: [],
            total: 0,
            page: 1,
            SizePage: 10,
            ReviewBlon: false,
            SetData: {
                status: -1,
                reason: "",
            },
            reviewInfo: {},
            ZhuanYeXinXiInfo: [],
            status_type: 0,
        }
    },
    props: {
        SearchInfo: {
            type: Object, //类型
            required: false, //必要性
            default: {} //默认值
        }
    },
    mounted() {
        this.getData()
    },
    methods: {
        shouldShowParent(item) {
            if (!item || !item.question_info) {
                return false;
            }
            const hasAnswer = item.answer !== undefined && item.answer !== null && item.answer !== '';
            const hasFiles = Array.isArray(item.fileList) && item.fileList.length > 0;
            const hasTemplateFiles = Array.isArray(item.templatefileList) && item.templatefileList.length > 0;
            return hasAnswer || hasFiles || hasTemplateFiles;
        },
        getData() {
            let params = {
                type: 2,
                page: this.page,
                limit: this.SizePage,
            }
           this.$post("api/user/myJudge", { ...params, ...this.SearchInfo }).then(res => {
    if (res.data.code == 1) {
        this.total = res.data.data.total;
        console.log('未未未:', res.data.data.data);
        const filteredData = res.data.data.data.filter(item => item.personnel != null);
        console.log('过滤:', filteredData);
        filteredData.forEach(item => {
            item.name = item.personnel.name;
            item.gender = item.personnel.gender == 1 ? '男' : '女';
            item.code = item.personnel.code;
            item.status = processStatus[item.status];
            item.mobile = item.personnel.mobile;
            item.user_group_name = item.user_group && item.user_group.name;
        });
        
        this.tableData = filteredData;
    } else {
        this.$message.error(res.data.msg);
    }
});
        },
        LockInfo(row) {
            this.$post("api/user/myJudgeDetails", {
                type: 2,
                ids: row.id,
            }).then(res => {
                if (res.data.code == 1) {
                    this.ReviewBlon = !this.ReviewBlon;
                    this.reviewInfo = res.data.data;
                    if(this.reviewInfo.case) {
                        this.reviewInfo.case.fileName = this.reviewInfo.case.file.split('\/').pop();
                        this.reviewInfo.case.type = this.reviewInfo.case.file.split('\.').pop();
                        this.reviewInfo.case.url = {
                            url: this.reviewInfo.case.file
                        };
                        if (this.reviewInfo.case.zixun_file) {
                            this.reviewInfo.case.zixun_fileName = this.reviewInfo.case.zixun_file.split('\/').pop();
                            this.reviewInfo.case.zixun_url = { url: this.reviewInfo.case.zixun_file };
                        }
                        if (this.reviewInfo.case.lunwen_file) {
                            this.reviewInfo.case.lunwen_fileName = this.reviewInfo.case.lunwen_file.split('\/').pop();
                            this.reviewInfo.case.lunwen_url = { url: this.reviewInfo.case.lunwen_file };
                        }
                        if (this.reviewInfo.case.wenzhang1_file) {
                            this.reviewInfo.case.wenzhang1_fileName = this.reviewInfo.case.wenzhang1_file.split('\/').pop();
                            this.reviewInfo.case.wenzhang1_url = { url: this.reviewInfo.case.wenzhang1_file };
                        }
                        if (this.reviewInfo.case.wenzhang2_file) {
                            this.reviewInfo.case.wenzhang2_fileName = this.reviewInfo.case.wenzhang2_file.split('\/').pop();
                            this.reviewInfo.case.wenzhang2_url = { url: this.reviewInfo.case.wenzhang2_file };
                        }
                    }
                    this.SetData.reason = this.reviewInfo.reason;
                    this.SetData.status = this.reviewInfo.status;
                    this.status_type = this.reviewInfo.status;
                    this.ZhuanYeXinXiInit();
                    this.TuijianXinxiInit();
                } else {
                    this.$message.error(res.data.msg)
                }
            })
        },
        TuijianXinxiInit() {
            let { information } = this.reviewInfo;
            // 兼容对象与数组两种返回
            if (!Array.isArray(information)) {
                information = information ? [information] : [];
            }
            information.forEach(info => {
                if (info.tutor) {
                    try {
                        let tutor = JSON.parse(info.tutor);
                        if (!Array.isArray(tutor)) tutor = [tutor];
                        info.tutor = tutor;
                    } catch (e) {}
                }
                if (info.mechanism) {
                    try { info.mechanism = JSON.parse(info.mechanism); } catch (e) {}
                }
                if (info.consultant) {
                    try {
                        let consultant = JSON.parse(info.consultant);
                        if (!Array.isArray(consultant)) consultant = [consultant];
                        info.consultant = consultant;
                    } catch (e) {}
                }
            });
            this.reviewInfo.information = information;
        },
        ZhuanYeXinXiInit() {
            var { question } = this.reviewInfo;
            if (!question || !Array.isArray(question)) {
                this.ZhuanYeXinXiInfo = [];
                return;
            }
            question.forEach(item => {
                // 处理父题目本身的类型转换和文件数据（用于没有子题的情况）
                if (item.question_info && item.question_info.type) {
                    if (typeof item.question_info.type === 'string') {
                        item.question_info.type = parseInt(item.question_info.type) || 0;
                    }
                }
                try {
                    if (item.file && item.file !== '[]' && typeof item.file === 'string') {
                        item.fileList = JSON.parse(item.file);
                    }
                    if (item.templatefile && item.templatefile !== '[]' && typeof item.templatefile === 'string') {
                        item.templatefileList = JSON.parse(item.templatefile);
                    }
                } catch (e) {
                    console.error('解析文件数据出错:', e);
                }
                
                // 处理子题目的数据
                if (item.children && item.children.length > 0) {
                    item.children.forEach(items => {
                        if (items.question_info && items.question_info.type) {
                            if (typeof items.question_info.type === 'string') {
                                items.question_info.type = parseInt(items.question_info.type) || 0;
                            }
                        }
                        try {
                            if (items.file && items.file !== '[]' && typeof items.file === 'string') {
                                items.fileList = JSON.parse(items.file);
                            }
                            if (items.templatefile && items.templatefile !== '[]' && typeof items.templatefile === 'string') {
                                items.templatefileList = JSON.parse(items.templatefile);
                            }
                        } catch (e) {
                            console.error('解析文件数据出错:', e);
                        }
                    });
                }
            });
            this.ZhuanYeXinXiInfo = question;
        },
        OpenLock(res) {
            this.$Global.previewFile(res)
        },
        OpenWeb(res) {
            window.open(res)
        },
        handleClick(t) {
            let text = '网盘地址:' + t.video_file + '网盘密码:' + t.password;
            this.$copyText(text).then(() => {
                this.$message.success('复制成功');
            }).catch(() => {
                this.$message.warning('复制失败');
            });
        },
        ReviewSuc() {
            if (!this.SetData.status) {
                this.$message.error("请选择审核状态!");
                return
            }
            if (this.SetData.status == 2 && !this.SetData.reason) {
                this.$message.error("请输入驳回理由!");
                return
            }
            this.$confirm("确认提交审核结果?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                var params = {
                    type: 2,
                    ids: this.reviewInfo.id,
                    status: this.SetData.status,
                }
                if (this.SetData.status == 2) {
                    params.reason = this.SetData.reason;
                }
                this.$post("api/user/examine", params).then(res => {
                    if (res.data.code == 1) {
                        this.$message.success(res.data.msg);
                        this.getData();
                        this.ReviewBlon = false;
                        this.SetData = {
                            status: "",
                            reason: "",
                        };
                    } else {
                        this.$message.error(res.data.msg)
                    }
                })
            }).catch(() => {
                this.$message.info("已取消提交");
            });
        },
        SizeChange(val) {
            this.SizePage = val;
            this.getData();
        },
        PageChange(val) {
            this.page = val;
            this.getData();
        },
    }
}
</script>
<style scoped>
.PageDis {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
}

.DigBtns {
    display: flex;
    align-items: center;
    justify-content: center;
}

.DigBtns .Btn {
    background-color: #f6faff;
    border-radius: 10px;
    border: solid 1px #d6e5ff;
    font-size: 16px;
    color: #2354f4;
    padding: 10px 40px;
    cursor: pointer;
}

.DigBtns .Btn:hover {
    box-shadow: 0 0 10px #b6d0ed;
}

.DigBtns .Btn.Blue {
    background-color: #027cfb;
    color: #fff;
    margin-left: 20px;
}

.CommDig {
    max-height: 600px;
    overflow: auto;
}

.Table {
    width: 99%;
    margin: 10px auto;
    border-radius: 5px;
    border-collapse: collapse;
}

.Table td {
    border: 1px solid #e4eaec;
    padding: 10px;
    font-weight: 400;
    font-size: 16px;
    color: #666;
}

.Table .State {
    padding-right: 10px;
}

.Table .Th {
    color: #000000;
    font-size: 16px;
    padding: 10px;
    font-weight: 700;
}

.Table td .Red {
    color: #d51938;
    font-weight: 700;
    vertical-align: middle;
    /* margin-right: 10px; */
}

.Table .TableDis {
    display: flex;
    align-items: center;
    justify-content: flex-end;
}

.WidMax {
    width: 100%;
}

.TitleBox {
    width: 100%;
    height: 40px;
    background-color: #0385EB;
    line-height: 42px;
    margin-top: 10px;
    padding-left: 15px;
    font-size: 18px;
    font-weight: 600;
    text-align: center;
    color: #ffffff;
    box-sizing: border-box;
}

.ZhuanYeWai .ZhuanYeTheme {
    font-size: 16px;
    font-weight: 600;
    margin: 10px 0;
}

.ZhuanYeBox {
    font-size: 16px;
    background-color: #F5F5F5;
    padding: 20px;
    margin-bottom: 10px;
}

.ZhuanYeBox .UploadTitle {
    font-size: 16px;
}

/* .ZhuanYeBox .ZhuanYeBoxInfo {
    margin-top: 20px;
} */

.ZhuanYeBoxFile {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    padding: 10px 10px 0 10px;
    border: 1px #0385EB solid;
    box-sizing: border-box;
}

.ZhuanYeBoxFile .FileItem {
    cursor: pointer;
    width: 90px;
    font-size: 14px;
    padding: 0 10px 10px 0;
}

.ZhuanYeBoxFile .FileItem .FileTitle {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    line-height: 15px;
    width: 90px;
    margin-top: 2px;
}

.ZhuanYeBoxFile .FileItem img {
    width: 90px;
    height: 90px;
}

.AnLIBaoGaoBox {
    margin-top: 20px;
}

.ZhuanYeItem {
    width: 500px;
}

.ZhuanYeItemRadio {
    margin-top: 10px;
}

.ZhuanYeItemRadio .radio-label {
    font-weight: 600;
    font-size: 16px;
}

.ZhuanYeItemTit {
    text-align: center;
    font-weight: 400;
    font-size: 16px;
    color: #666666;
    padding: 10px 0;
}

.ZhuanYeItemDis {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
}

.ZhuanYeItemCont {
    width: 75%;
    margin: 10px 0 0 10px;
}

.ZhuanYeItemFuTit {
    font-weight: 400;
    font-size: 16px;
    color: #666666;
    width: 30%;
}

.ZhuanYeItemVal {
    margin-left: 20px;
    flex: 1;
}

.DigItem {
    display: flex;
    margin: 20px 0;
}

.DigItem .DigTit {
    font-size: 16px;
    color: #000000;
    width: 80px;
}

.DigItem input,
.DigItem textarea {
    border-radius: 10px;
    border: solid 1px #e1e1e1;
    padding: 15px;
    flex: 1;
}

.DigItem .DigSelect {
    width: 300px;
    margin: 0;
}

.SupervisorBox {
    padding-left: 20px;
}

.SpanColorRed {
    color: red;
}
</style>
<style>
.ProfessionalReview .el-dialog__body {
    padding: 0 20px 20px 20px;
}
</style>